import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowRightLeft } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const sel = "w-full bg-muted/60 border h-9 px-2 text-sm disabled:opacity-50";
const LABEL = { leads: "Open leads", uids: "Open UIDs" };

const summary = (r) => {
  const n = (k) => r[k].owner + r[k].backup;
  let s = `Moved ${n("leads")} lead(s) and ${n("uids")} UID(s)`;
  if (r.alerted.length) s += ` · ${r.alerted.join(", ")} told by bell and email`;
  if (r.no_login.length) s += ` · ${r.no_login.join(", ")} has no login, so no alert`;
  return s;
};

const Part = ({ k, c, value, onChange, opts }) => {
  const total = c ? c[k].owner + c[k].backup : 0;
  return (
    <div className="border p-3" data-testid={`handover-${k}`}>
      <div className="text-sm font-medium">{LABEL[k]}</div>
      <div className="text-xs text-muted-foreground mb-2" data-testid={`handover-${k}-count`}>{c ? `${c[k].owner} as owner · ${c[k].backup} as backup` : "Loading…"}</div>
      <select data-testid={`handover-${k}-to`} disabled={!total} className={sel} value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{total ? "Keep as they are" : "Nothing to move"}</option>{opts.map((n) => <option key={n} value={n}>{n}</option>)}</select>
    </div>
  );
};

export const HandoverDialog = ({ name, team, onClose, onDone }) => {
  const [c, setC] = useState(null);
  const [f, setF] = useState({ leads: "", uids: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/handover", { params: { name } }).then((r) => setC(r.data)).catch((e) => toast.error(errMsg(e))); }, [name]);
  const opts = team.filter((n) => n !== name);
  const go = () => {
    setBusy(true);
    api.post("/admin/handover", { from_name: name, leads_to: f.leads || null, uids_to: f.uids || null })
      .then((r) => { toast.success(summary(r.data)); onDone(); }).catch((e) => toast.error(errMsg(e))).finally(() => setBusy(false));
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg bg-card" data-testid="handover-dialog">
        <DialogHeader><DialogTitle className="font-display">Hand over {name}'s open records</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Moves every open lead and open UID where {name} is the owner or backup owner. Closed records keep {name}'s name.
          The new owner gets a bell alert and an email, and each record notes the handover.</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {["leads", "uids"].map((k) => <Part key={k} k={k} c={c} value={f[k]} onChange={(v) => setF({ ...f, [k]: v })} opts={opts} />)}
        </div>
        <button data-testid="handover-submit" disabled={busy || !(f.leads || f.uids)} onClick={go} className="bg-primary text-primary-foreground h-9 px-4 text-sm flex items-center justify-center gap-2 disabled:opacity-50">
          <ArrowRightLeft className="h-4 w-4" />{busy ? "Moving…" : "Hand over"}</button>
      </DialogContent>
    </Dialog>
  );
};
